var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"user-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/profile"}},[_c('icon',{attrs:{"icon":"essentials/security/face-id-alt"}}),_vm._v(" My Profile")],1)],1),_vm._v(" "),_c('li',[_c('logout-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }